import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SearchService } from '../../../../shared/search/search.service';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { HttpClient } from '@angular/common/http';
import { AlertService } from 'sce-core';
import { PickManagementDataEditorService } from './pick-management-editor.service';
import { SearchableEntityConfig } from '../../../../shared/models/searchable-entity-config';
import { ResourceService } from 'sce-core';
import { PickManagementButtonService } from './pick-management-button.service';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DataTableConfig } from '../../../../shared/search/models/data-table-config';
import { LFTabChangeEvent } from '../../../../shared/components/platform/lf-tabbedpane/lf-tab-change-event';
import { DetailedEntityDataService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { PickManagementFilterSearchService } from './pick-management-filter-search.service';
import { PickManagementKeyEventHandlerService } from './pick-management-key-event-handler.service';
import { TAB_LIST } from './pick-management-tables';
import { ALLOCATION_STATUS, SEARCH_KEYS } from 'app/constants';

@Injectable()
export class PickManagementDataService extends DetailedEntityDataService {

  public entityConfig: SearchableEntityConfig;
  public pickSearchService: SearchService;
  public pickSearchParams: SearchParams;
  public searchStatus: SearchStatus;
  public orderStatus: any;

  public paPickSearchService: SearchService;
  public paPickSearchParams: SearchParams;
  public selectedTab: any = 0;
  public displayMode: string = 'V';
  public selectedHeader: Array<string> = [];
  public primarySelectedDocument: string;
  public searchServices: Array<SearchService> = [];

  public lookupMap: any = {};
  public shortPickSearchService: SearchService;
  public shortPickSearchParams: SearchParams;
  public nfaPickSearchService: SearchService;
  public nfaPickSearchParams: SearchParams;
  public pickSerialNoSearchParams: SearchParams;
  public pickSerialNoSearchService: SearchService;
  public pmButtonService: PickManagementButtonService;

  public filterSearchService: SearchService;
  public resultSearchService: SearchService;
  public selectedViewType: string;

  public selectedRows;

  private showDetailsPageSubject: Subject<any> = new Subject();

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected http$: HttpClient, public alertService: AlertService,
    public dataEditor: PickManagementDataEditorService, protected resourceService: ResourceService,
    protected sharedServiceRegistry: SharedServiceRegistry) {
      super(coreServiceRegistry, sharedServiceRegistry);
    /* this.searchServices.push(this.createPickSearchServices());
    this.searchServices.push(this.createPAPickSearchServices());
    this.searchServices.push(this.createShortPickSearchServices());
    this.searchServices.push(this.createNFAPickSearchServices()); */
    for (let key in TAB_LIST) {
      if (!isNaN(Number(key))) {
          continue; 
      }
      this.selectedHeader.push(key);
    }
  }

  public getNewFilterSearchService(): SearchService {
      return this.initializeSearchContext();
  }
  public getFilterSearchService(): SearchService {
      return this.filterSearchService;
  }
  public getSeletedViewType(): string {
      return this.selectedViewType;
  }
  public setSeletedViewType(viewType) {
      this.selectedViewType = viewType;
  }

  public showDetailsPageEvent(): Observable<any> {
    return this.showDetailsPageSubject.asObservable();
  }

  public sendShowDetailsPageEvent(event: any) {
    this.showDetailsPageSubject.next(event);
  }

  /**
   * This method loads the search configuration from the entity config and creates a search service
   */
  public initializeSearchContext(): SearchService {
      const searchParams = this.entityConfig.getPrimarySearchParams();
      searchParams.tableEditor = this.dataEditor;
      searchParams.alertService = this.alertService;
      const tableConfig: DataTableConfig = new DataTableConfig();
      tableConfig.supportFiltering = true;
      searchParams.dataTableConfig = tableConfig;
      const searchStatus = new SearchStatus();
      // this is the search service for the filter
      this.filterSearchService
          = new PickManagementFilterSearchService(this.coreServiceRegistry.http$,
              searchParams, searchStatus,
              this.coreServiceRegistry.resourceService,
              this.sharedServiceRegistry.userPreferencesService,
              this.sharedServiceRegistry.alertService,
              this.sharedServiceRegistry.dateConfigService);
      this.searchService = this.filterSearchService;
      return this.searchService;
  }


  public setDependentService(buttonService: PickManagementButtonService) {
    this.pmButtonService = buttonService;
  }
  public initializePickContexts() {
    this.searchServices.push(this.createPickSearchServices());
    this.searchServices.push(this.createPAPickSearchServices());
    this.searchServices.push(this.createShortPickSearchServices());
    this.searchServices.push(this.createNFAPickSearchServices());
    this.searchServices.push(this.createPickSerialNoSearchServices());
  }
  public createPickSearchServices(): SearchService {
    this.pickSearchParams = new SearchParams();
    this.pickSearchParams.tableId = 'picktd';
    this.pickSearchParams.isFullFetch = true;
    this.pickSearchParams.idProperty = 'pickDetailKey';
    this.pickSearchParams.tableEditor = this.dataEditor;
    this.pickSearchParams.alertService = this.alertService;
    const dataTableConfig: DataTableConfig = new DataTableConfig();
    dataTableConfig.editable = true;
    this.pickSearchParams.dataTableConfig = dataTableConfig;
    this.pickSearchParams.dataTableConfig.keyEventHandler = new PickManagementKeyEventHandlerService(this.dataEditor);
    this.pickSearchParams.dataTableConfig.isColumnEditable = function (params: any) {
      const rowData = params.data;
      const componentRef = params.context.componentParent;
      if (['V', 'P'].indexOf(componentRef.tableMode) !== -1) {
        return false;
      }
      if (!rowData) {
        return false;
      }
      const isNewRow: boolean = rowData && rowData['isNewItem'] && rowData['isNewItem'].cVal;
      if (isNewRow) {
        //LFWM-3557 enable the column only if it is an editable field in the metadata
        return (['E', 'EL', 'EA'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
      } else {
        // check for status to disable caseID>=5 and storerconfig = 1
        const isCaseIDDisabled = rowData['status'] && rowData['status'].cVal >= ALLOCATION_STATUS.PICKED && params.colDef.colId === SEARCH_KEYS.CASE_ID
                                 && !componentRef.tableEditor.isCaseIDEditable;
        if (isCaseIDDisabled) {
          return false;
        }
        //LFWM-3557 For existing record, OrderLineNo will be non-editable.
        if (componentRef.metaDataMap[params.colDef.colId].propertyName == "orderLineNo") {
          return false;
        } else {
          return (['E', 'EL', 'L', 'EA'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
        }
      }
    };
    if (this.pmButtonService) {
      this.pickSearchParams.actionButtons = this.pmButtonService.getButtonsForPanel('detail-table');
    }
    this.searchStatus = new SearchStatus();
    this.pickSearchService = this.sharedServiceRegistry.createSearchService(this.pickSearchParams, this.searchStatus);
    return this.pickSearchService;
  }
  public createPAPickSearchServices(): SearchService {
    this.paPickSearchParams = new SearchParams();
    this.paPickSearchParams.tableId = 'prepickdetailtd';
    this.paPickSearchParams.isFullFetch = true;
    this.paPickSearchParams.idProperty = 'preAllocPickDtlKey';
    this.paPickSearchParams.tableEditor = this.dataEditor;
    this.paPickSearchParams.alertService = this.alertService;
    if (this.pmButtonService) {
      this.paPickSearchParams.actionButtons = this.pmButtonService.getButtonsForPanel('detail-table');
    }
    this.searchStatus = new SearchStatus();
    this.paPickSearchService = this.sharedServiceRegistry.createSearchService(this.paPickSearchParams, this.searchStatus);
    return this.paPickSearchService;
  }
  public createShortPickSearchServices(): SearchService {
    this.shortPickSearchParams = new SearchParams();
    this.shortPickSearchParams.tableId = 'shortpicktd';
    this.shortPickSearchParams.isFullFetch = true;
    this.shortPickSearchParams.idProperty = 'orderKey';
    this.shortPickSearchParams.tableEditor = this.dataEditor;
    this.shortPickSearchParams.alertService = this.alertService;
    const dataTableConfig: DataTableConfig = new DataTableConfig();
    dataTableConfig.editable = true;
    this.shortPickSearchParams.dataTableConfig = dataTableConfig;
    if (this.pmButtonService) {
      this.shortPickSearchParams.actionButtons = this.pmButtonService.getButtonsForPanel('detail-table');
    }
    this.searchStatus = new SearchStatus();
    this.shortPickSearchService = this.sharedServiceRegistry.createSearchService(this.shortPickSearchParams, this.searchStatus);
    return this.shortPickSearchService;
  }
  public createNFAPickSearchServices(): SearchService {
    this.nfaPickSearchParams = new SearchParams();
    this.nfaPickSearchParams.tableId = 'unallocordertd';
    this.nfaPickSearchParams.isFullFetch = true;
    this.nfaPickSearchParams.idProperty = 'orderKey';
    this.nfaPickSearchParams.tableEditor = this.dataEditor;
    this.nfaPickSearchParams.alertService = this.alertService;
    this.searchStatus = new SearchStatus();
    //[LFWM-3529] button service for unallocordertd table id
    //this.nfaPickSearchParams.actionButtons = [];    
    if (this.pmButtonService) {
      this.nfaPickSearchParams.actionButtons = this.pmButtonService.getButtonsForPanel('detail-table');
    }
    this.nfaPickSearchService = this.sharedServiceRegistry.createSearchService(this.nfaPickSearchParams, this.searchStatus);
    return this.nfaPickSearchService;
  }
  public createPickSerialNoSearchServices(): SearchService {
    this.pickSerialNoSearchParams = new SearchParams();
    this.pickSerialNoSearchParams.tableId = 'pickserialnotd';
    this.pickSerialNoSearchParams.isFullFetch = true;
    this.pickSerialNoSearchParams.idProperty = 'orderKey';
    this.pickSerialNoSearchParams.tableEditor = this.dataEditor;
    this.pickSerialNoSearchParams.alertService = this.alertService;
    const dataTableConfig: DataTableConfig = new DataTableConfig();
    dataTableConfig.editable = true;
    this.pickSerialNoSearchParams.dataTableConfig = dataTableConfig;
    this.pickSerialNoSearchParams.dataTableConfig.keyEventHandler = new PickManagementKeyEventHandlerService(this.dataEditor);
    this.pickSerialNoSearchParams.dataTableConfig.isColumnEditable = function (params: any) {
      const rowData = params.data;
      const componentRef = params.context.componentParent;
      if (['V', 'P'].indexOf(componentRef.tableMode) !== -1) {
        return false;
      }
      if (!rowData) {
        return false;
      }
      const isNewRow: boolean = rowData && rowData['isNewItem'] && rowData['isNewItem'].cVal;
      if (isNewRow) {
        //enable the column only if it is an editable field in the metadata
        return (['E', 'EL', 'EA'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
      } else {
        //For existing record, OrderLineNo will be non-editable.
        if (componentRef.metaDataMap[params.colDef.colId].propertyName == "orderKey") {
          return false;
        } else {
          return (['E', 'EL', 'L', 'EA'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
        }
      }
    };
    if (this.pmButtonService) {
      this.pickSerialNoSearchParams.actionButtons = this.pmButtonService.getButtonsForPanel('detail-table');
    }
    this.searchStatus = new SearchStatus();
    this.pickSerialNoSearchService = this.sharedServiceRegistry.createSearchService(this.pickSerialNoSearchParams, this.searchStatus);
    return this.pickSerialNoSearchService;
  }

  public getPrimarySelectedDocument() {
    return this.primarySelectedDocument;
  }

  public setPrimarySelectedDocument(pickSearchService: string) {
    this.primarySelectedDocument = pickSearchService;
  }
  public getPickSearchService() {
    return this.pickSearchService;
  }

  public setPickSearchService(pickSearchService: SearchService) {
    this.pickSearchService = pickSearchService;
  }
  public getPickSerialNoSearchService() {
    return this.pickSerialNoSearchService;
  }

  public setPickSerialNoSearchService(pickSerialNoSearchService: SearchService) {
    this.pickSerialNoSearchService = pickSerialNoSearchService;
  }
  public getPaPickSearchService() {
    return this.paPickSearchService;
  }

  public setPaPickSearchService(paPickSearchService: SearchService) {
    this.paPickSearchService = paPickSearchService;
  }
  public getDisplayMode() {
    return this.displayMode;
  }

  public setDisplayMode(displayMode: string) {
    this.displayMode = displayMode;
  }
  public getOrderStatus() {
    return this.orderStatus;
  }

  public setOrderStatus(orderStatus: any) {
    this.orderStatus = orderStatus;
  }

  // method used to alert the user before switching to next tab if have unsaved changes in the current tab
  public preTabChange(event: LFTabChangeEvent) {
    const editedRows = this.searchServices[this.selectedTab].getEditedRows();
    if (editedRows.length > 0) {
      this.sharedServiceRegistry.confirmDialogService.okDialog(this.resourceService.get('err_unsaved_data'));
      event.hasError = true;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/pick-management/services/pick-management-data.service.ts